(function() {
  window.onload = () => {
    if (window.location.href.indexOf("h5Page") !== -1) {
      getRem(720, 100);
    } else {
      getRem(0, 0);
    }
  };
  window.onresize = () => {
    if (window.location.href.indexOf("h5Page") !== -1) {
      getRem(720, 100);
    } else {
      getRem(0, 0);
    }
  };
  function getRem(pwidth, prem) {
    let html = document.getElementsByTagName("html")[0];
    var oldWidth = html.clientWidth || document.documentElement.clientWidth;
    if (pwidth == 0 && prem == 0) {
      html.style.fontSize = "40px";
    } else {
      html.style.fontSize = (oldWidth / pwidth) * prem + "px";
    }
  }
})();
